import { Navigate } from "react-router-dom";
import { useUser } from "@hooks";

const IndexPage = () => {
  const user = useUser();

  // Redirect to homepage, user.role.homepage or based on isInspector
  let homepage = user.isInspector()
    ? "/inspector/activities"
    : user.user.role?.homepage || "/activities";

  if (!homepage.startsWith("/")) {
    homepage = "/" + homepage;
  }

  return <Navigate to={homepage} replace />;
};

export default IndexPage;
